module.exports = __webpack_public_path__ + "static/img/cp_dzhg_logo.a811892.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/cp_dzhg_logo.png
// module id = SQ+N
// module chunks = 0